var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'background': _vm.$route.name === 'home' ? '#fff' : '#F3F3F3'}),attrs:{"id":"app"}},[(_vm.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.key})],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }